import CyclingRegularIcon from './CyclingRegularIcon'
import DrivingCarIcon from './DrivingCarIcon'
import FootWalkingIcon from './FootWalkingIcon'

export { CyclingRegularIcon, DrivingCarIcon, FootWalkingIcon }
